import { connect } from 'react-redux';
import PartyWrap from 'components/parties/PartyWrap';
import { clearCurrentParty } from 'data/parties/Parties.actions';

export default connect(
  () => ({}),
  dispatch => ({
    clear: () => dispatch(clearCurrentParty()),
  }),
)(PartyWrap);
